const Layout = ({ children }) => {
  return (
    <div class="container">
      <div class="container-inner">
        <div class="logo-wrapper">
          <svg
            id="a"
            xmlns="http://www.w3.org/2000/svg"
            xmlnsXlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 263.6078 64.4005"
          >
            <defs>
              <style>{`.d{fill:url(#d);}.e{fill:none;}.f{clip-path:url(#b);}`}</style>
              <clipPath id="b">
                <path
                  d="M30.1577,4.8483l-3.7119,3.9121c-2.1118-1.9102-5.0444-3.0376-8.8882-3.0449-4.1587,.0078-7.0649,1.4243-7.6201,5.1338-.3076,2.2261,.6514,2.9805,6.9141,4.7827,5.2568,1.4102,12.0786,3.0615,11.0649,10.5908-.9863,7.3838-8.5439,10.416-14.626,10.416-5.4517,0-10.8208-2.4229-13.2905-6.0767l3.7783-3.7241c1.9736,2.9209,6.1416,4.3916,9.7095,4.375,4.1895,.0181,7.7056-1.9766,8.1865-5.3857,.4399-3.123-2.2837-3.6001-6.8472-4.9629C6.3281,18.466,2.873,16.3894,3.7026,10.4309,4.7925,2.8937,11.5044,.2365,17.8716,.2365c5.3457,0,9.5791,1.8994,12.2861,4.6118Zm21.3662,1.1685l-4.2056,29.9219h-6.1392l4.2051-29.9219h-10.9106l.7144-5.0801h27.9609l-.7139,5.0801h-10.9111Zm34.5234,15.7065l6.3545,14.2153h-6.9756l-5.3062-13.6196h-7.8623l-1.9141,13.6196h-6.1006L69.1626,.9367h16.0742c5.6011,0,9.7788,4.3589,8.8203,10.9087-.6958,4.9482-3.9746,8.5254-8.0098,9.8779Zm-1.6089-15.7065h-9.8896l-1.5781,11.228h9.7065c2.3955,0,4.8228-2.0991,5.3501-5.8535,.5093-3.4751-1.1743-5.3745-3.5889-5.3745Zm23.0376,9.0527h15.856l-.7144,5.0801h-15.856l-1.5049,10.709h18.3057l-.7139,5.0801h-24.4062L103.3618,.9367h23.9058l-.7139,5.0801h-17.8057l-1.272,9.0527Zm46.7505,20.8691l-1.6895-7.4932h-15.5498l-3.7954,7.4932h-6.6191L145.1431,.9367h6.7974l8.7319,35.002h-6.4458Zm-2.7979-12.5732l-3.6362-16.1826-8.269,16.1826h11.9053Zm51.083,12.5732h-6.0122l3.3135-23.8145-10.958,13.2759h-5.6304l-7.3804-13.4805-3.3403,24.019h-6.0122L171.4111,.9367h5.3647l.0649,.1963,9.9087,18.707L201.9331,.9367l.0259,.0161,.0098-.0161h5.4619l-4.9189,35.002Zm60.8421-14.9781c-1.2665,9.0118-7.0955,15.6379-14.3021,18.3833l11.1831,25.0566h-17.6372l-8.3547-23.6589h-10.0355l-3.3254,23.6589h-15.9569L213.8446,.9367h33.17c10.4272,0,18.1046,7.9738,16.3402,20.0239h-.001Zm-21.7701,6.6959c2.8997,0,6.1563-2.4702,6.7854-6.9446,.6266-4.2759-1.8504-6.6458-4.7733-6.6458h-15.6394l-1.9104,13.5904h15.5376Zm-111.86,31.5821c-.4123,2.9371,1.2742,3.9893,3.3234,3.9786,1.2389-.0061,2.5172-.373,3.601-.9547l.3552,.9573c-1.2849,.7506-2.8147,1.1716-4.1996,1.1787-2.6539,.0133-4.8986-1.4946-4.372-5.2405l1.5364-10.9327h-3.4714l.1527-1.0923,3.2626-.0109h.2113l1.0892-7.7493h1.3039l-1.0898,7.7493h7.0071l-.1546,1.1032h-7.0071l-1.5482,11.0133Zm28.7673-4.4751c-.0163,.1383-.0378,.2852-.0628,.4317h-15.2384c-.0133,.1041-.0255,.2077-.0367,.321-.4878,4.3144,1.836,7.6358,6.0218,7.6358,1.9952,0,4.2455-.694,6.4198-2.0814l.3393,.9389c-2.2702,1.5798-4.8099,2.3906-6.9306,2.3906-5.114,0-7.9088-4.147-7.1883-9.2763,.7231-5.1451,4.6639-9.2732,9.7555-9.238,5.3553,0,7.4812,3.9347,6.9204,8.8778Zm-15.0919-.6715l13.8116-.0189c.2648-3.9919-1.5104-6.9392-5.7523-6.9392-3.9863-.0214-7.127,2.9652-8.0593,6.9581Zm30.417-8.2063c2.1513,0,4.4226,.8205,6.2473,2.3631l-.4485,.9496c-1.7957-1.3936-3.8658-2.0641-5.8345-2.0641-4.442-.0225-7.9062,3.3938-8.5548,8.0889-.6281,4.4715,1.7707,7.9287,6.1728,7.9287,2.0875,0,4.3608-.7465,6.4769-2.0962l.2873,1.0405c-2.1651,1.4778-4.5884,2.3044-6.8678,2.3044-5.189,0-8.143-4.1781-7.4179-9.3375,.7384-5.2553,4.8017-9.2115,9.9386-9.1773h.0005Zm21.2744,.001c3.3045,.001,5.7003,2.2386,5.0829,6.631l-1.6336,11.8828h-1.3273l1.6688-11.9629c.5036-3.5852-1.365-5.3166-4.0791-5.3145-2.2605,.002-5.0456,1.1782-7.5368,3.574l-1.9986,13.7035h-1.2271l3.515-25.0372h1.3032l-1.3971,9.9427c2.58-2.3794,5.3758-3.4194,7.6296-3.4188v-.0005Zm-72.2808,1.2488l-122.8014-.0021v1.0927H122.6495l.1602-1.0906Z"
                  style={{ fill: "none" }}
                />
              </clipPath>
              <linearGradient
                id="d"
                x1="19.3396"
                y1="-32.791"
                x2="244.4758"
                y2="97.1915"
                gradientTransform="matrix(1, 0, 0, 1, 0, 0)"
                gradientUnits="userSpaceOnUse"
              >
                <stop offset="0" stop-color="#055ddb">
                  <animate
                    attributeName="stop-color"
                    values="#055ddb;#68e0cf;#055ddb;"
                    dur="20s"
                    repeatCount="indefinite"
                  ></animate>
                </stop>
                <stop offset="1" stop-color="#68e0cf">
                  <animate
                    attributeName="stop-color"
                    values="#68e0cf;#055ddb;#68e0cf;"
                    dur="20s"
                    repeatCount="indefinite"
                  ></animate>
                </stop>
              </linearGradient>
            </defs>
            <g style={{ clipPath: "url(#b)" }}>
              <rect
                x=".4077"
                width="263"
                height="64.4005"
                style={{ fill: "url(#d)" }}
              />
            </g>
          </svg>
        </div>
        <div class="content-wrapper">
          <h1>twitch partner plus goal tracker widget</h1>
          {children}
        </div>
      </div>
    </div>
  );
};

export default Layout;
